import React from 'react';
import PromotionServicePage from './PromotionServicePage';

const SpotifyPromotionPage = () => {
  return (
    <PromotionServicePage
      platform="spotify"
      platformName="Spotify"
      iconColor="bg-green-500"
      description="Faites la promotion pour avoir des Hits, abonnés, et entrées en playlists."
      metaTitle="Promotion Spotify - 35$ | AGRP BOX"
      metaDescription="Boostez votre présence sur Spotify : plus de streams, d'abonnés et de placements en playlists officielles avec AGRP BOX."
      url="/promouvoir-spotify"
    />
  );
};

export default SpotifyPromotionPage;
